<template>
  <OrderCard :title="t('order.cardTitles.product')">
    <FormField v-slot="{ componentField }" name="order_item.product_item_name">
      <FormItem>
        <FormLabel>{{ t("order.formLabels.product") }}</FormLabel>
        <Select v-bind="componentField">
          <FormControl>
            <SelectTrigger class="!h-10 w-full">
              <SelectValue />
            </SelectTrigger>
          </FormControl>
          <SelectContent>
            <SelectGroup>
              <SelectItem v-for="type in ['Borówka']" :key="type" :value="type">
                {{ type }}
              </SelectItem>
            </SelectGroup>
          </SelectContent>
        </Select>
        <FormMessage />
      </FormItem>
    </FormField>

    <FormField v-slot="{ componentField }" name="order_item.quantity">
      <FormItem>
        <FormLabel for="quantity">{{
          t("order.formLabels.quantity")
        }}</FormLabel>
        <FormControl>
          <Input
            id="quantity"
            v-bind="componentField"
            type="number"
            :min="minimumQuantity"
            step="1"
            @input="onQuantityInput"
          />
        </FormControl>
        <FormMessage />
      </FormItem>
    </FormField>
  </OrderCard>
</template>
<script setup lang="ts">
import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from "../../form";
import {Input} from "../../input";
import {
  Select,
  SelectTrigger,
  SelectValue,
  SelectContent,
  SelectItem,
  SelectGroup,
} from "../../select";

import type { FormContext } from "vee-validate";
import { useI18n } from "vue-i18n";
import { OrderCard } from "../../card";

const { t } = useI18n();
const props = withDefaults(
  defineProps<{
    form: FormContext;
    minimumQuantity?: number;
  }>(),
  {
    minimumQuantity: 1,
  },
);

const onQuantityInput = (e: Event) => {
  const input = e.target as HTMLInputElement;

  let cleaned = input.value.replace(/\D+/g, "");

  cleaned = cleaned.replace(/^0+/, "");

  input.value = cleaned;
  props.form.setFieldValue("order_item.quantity", cleaned);
};
</script>
